(() => {
  const key = 'ofk-new-arrivals-2026-11-dismissed-until';
  function init(dialog) {
    if (dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
    dialog.dataset.initialized = 'true';
    const previewRequested = new URLSearchParams(location.search).get('ofk_new_drop_preview') === '1';
    const preview = dialog.dataset.previewAllowed === 'true' && (previewRequested || window.Shopify?.designMode);
    const start = Number(dialog.dataset.start);
    if (!preview && Date.now() < start) return;
    let memoryDismissed = false;
    let previousFocus;
    let timerReady = false;
    let interacted = false;
    const dismissed = () => {
      try { return memoryDismissed || Number(localStorage.getItem(key)) > Date.now(); }
      catch { return memoryDismissed; }
    };
    const remember = () => {
      if (preview) return;
      memoryDismissed = true;
      try { localStorage.setItem(key, String(Date.now() + Number(dialog.dataset.dismissDays) * 86400000)); } catch {}
    };
    const close = () => { remember(); dialog.close(); };
    const slides = [...dialog.querySelectorAll('[data-drop-slide]')];
    const pauseButton = dialog.querySelector('[data-drop-autoplay]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let autoplayPaused = reducedMotion.matches;
    let activeIndex = 0;
    let autoplayTimer;
    const stopAutoplay = () => {
      window.clearInterval(autoplayTimer);
      autoplayTimer = undefined;
    };
    const syncAutoplay = () => {
      stopAutoplay();
      if (pauseButton) {
        pauseButton.dataset.paused = String(autoplayPaused);
        pauseButton.setAttribute('aria-label', autoplayPaused ? pauseButton.dataset.playLabel : pauseButton.dataset.pauseLabel);
      }
      if (!dialog.open || document.hidden || autoplayPaused || slides.length < 2) return;
      autoplayTimer = window.setInterval(() => {
        if (!dialog.open || !dialog.isConnected || document.hidden) { stopAutoplay(); return; }
        select(String((activeIndex + 1) % slides.length));
      }, 3000);
    };
    const select = (index) => {
      activeIndex = Number(index);
      dialog.querySelectorAll('[data-drop-slide]').forEach(slide => { slide.hidden = slide.dataset.dropSlide !== index; });
      dialog.querySelectorAll('[data-drop-select]').forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.dropSelect === index)); });
    };
    dialog.querySelectorAll('[data-drop-select]').forEach(button => button.addEventListener('click', () => {
      select(button.dataset.dropSelect);
      syncAutoplay();
    }));
    pauseButton?.addEventListener('click', () => { autoplayPaused = !autoplayPaused; syncAutoplay(); });
    reducedMotion.addEventListener('change', event => { autoplayPaused = event.matches; syncAutoplay(); });
    document.addEventListener('visibilitychange', syncAutoplay);
    dialog.querySelectorAll('[data-drop-close]').forEach(button => button.addEventListener('click', close));
    dialog.querySelector('[data-drop-cta]')?.addEventListener('click', remember);
    dialog.addEventListener('cancel', () => remember());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    dialog.addEventListener('close', () => {
      stopAutoplay();
      document.documentElement.classList.remove('ofk-drop-open');
      previousFocus?.focus({ preventScroll: true });
      document.removeEventListener('scroll', onScroll);
    });
    const blockedByAnotherDialog = () => [...document.querySelectorAll('dialog[open], .modal--is-active, .pswp--open, #shopify-pc__banner, [aria-modal="true"]:not(.ofk-drop):not([hidden])')].some(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    const open = () => {
      if (!preview && (!timerReady || !interacted || dismissed() || document.hidden || blockedByAnotherDialog())) return;
      if (dialog.open || !dialog.isConnected) return;
      previousFocus = document.activeElement;
      dialog.showModal();
      dialog.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
      syncAutoplay();
      document.documentElement.classList.add('ofk-drop-open');
    };
    function onScroll() { if (window.scrollY >= 80) { interacted = true; open(); } }
    if (preview) { open(); return; }
    if (dismissed()) return;
    document.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) open(); });
    window.setTimeout(() => { timerReady = true; onScroll(); }, Number(dialog.dataset.delay));
  }
  document.querySelectorAll('[data-ofk-drop]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ofk-drop]').forEach(init));
})();
